import { render, staticRenderFns } from "./app-edit-shape.vue?vue&type=template&id=30346f42&scoped=true"
import script from "./app-edit-shape.vue?vue&type=script&lang=js"
export * from "./app-edit-shape.vue?vue&type=script&lang=js"
import style0 from "./app-edit-shape.vue?vue&type=style&index=0&id=30346f42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30346f42",
  null
  
)

export default component.exports